<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
include /@ibkr/lib.common/src/icon/arrow
div(class="border-bottom")
    ib-row(:class="{ 'pb-16': !$media.xl }")
        ib-col(class="xl2")
            p(
                class="insety-16", 
                :class="{'insetx-4': !$media.m, 'insetx-8': $media.l, 'insetx-16': $media.xl}"
            )
                span(
                    class="insetx-4 info", 
                    :class="{'start-0': !$media.m}"
                )
                    +icon-basic-info_filled
                    span(class="tooltext") {{ $t('choose_country') }}
                span {{ $t('country_of_residence') }}
        ib-col(
            class="xl10 start-4 end-4",
            :class="{ 'pt-0': !$media.xl, 'start-16': $media.m, 'insety-16': $media.xl, 'pr-0': $media.xl, 'end-16': $media.m }",
        )
            ib-dropdown(
                v-model="selectedCountry",
                :data="countriesList",
                style="width: 100%;",
                filtered
            )
</template>

<script>
    import { mapState, mapActions}  from 'vuex';
    import cloneDeep from 'lodash.clonedeep';

    export default {
        name: 'CountryOfResidence',
        data () {
            return {
            }
        },
        methods: {
            ...mapActions(['setSelectedCountry', 'setDefaultRegion'])
        },
        computed: {
            countriesList: function() {
                const countries = [];
                const clonedCountries = cloneDeep(this.countries);
                const sortedCountries = clonedCountries.sort((c1, c2) => (c1.name < c2.name) ? -1 : (c1.name > c2.name) ? 1 : 0);
                countries[0] = { label: this.$t('select_your_country_of_residence'), value: "" };
                for (let i = 1; i < sortedCountries.length; i++) {
                    if(i === 1) {
                        countries[i] = { label: sortedCountries.filter(country => country.value === 'US').map(country => country.name)[0], value: sortedCountries.filter(country => country.value === 'US').map(country => country.name)[0] };
                    }
                    countries[i+1] = {label: this.$t(sortedCountries[i].name), value: sortedCountries[i].name};
                }
                return countries;
            },
            selectedCountry: {
                get: function() {
                    return this.$store.state.selectedCountry;
                },
                set: function(newValue) {
                    this.setSelectedCountry(newValue);
                    const reg = this.regions.filter(region => region.name === this.selectedCountry).map(region => region.region);
                    this.setDefaultRegion(reg[0]);
                    this.setSelectedCountry(newValue);
                }
            },
            ...mapState(['countries', 'regions']),
        },
    }
</script>

<style lang="less" scoped>
</style>